import PropTypes from 'prop-types'

export const sanityExternalLinkPropTypes = {
  _type: PropTypes.oneOf(['externalLink']),
  href: PropTypes.string,
  blank: PropTypes.bool,
}

export type SanityExternalLinkProps = PropTypes.InferType<typeof sanityExternalLinkPropTypes>
